import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aogprgmpxh: FaireBrandEntity = {
  token: "b_aogprgmpxh",
  type: "brand",
  name: "GRACE+EMMA by Southern Grace",
  avatarUrl:
    "https://cdn.faire.com/fastly/886c92e61b825d6edfc557b194de2912f79612d1453f2dd386dc1c844bfee8cf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e864384b947b90218a2cd2e6218bf3137bd89bb21960ed0a66ef147d27ccc5cf.png",
  logoUrl:
    "https://cdn.faire.com/fastly/886c92e61b825d6edfc557b194de2912f79612d1453f2dd386dc1c844bfee8cf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e864384b947b90218a2cd2e6218bf3137bd89bb21960ed0a66ef147d27ccc5cf.png",
  location: "Carrollton, TX, USA",
  minimumOrderDollars: 137,
  rating: 4.9,
  reviewCount: 584,
  isTopShop: true,
  isInsider: true,
  description:
    "At GRACE+EMMA, we believe grace is more than a quality—it’s a way of living. For over a decade, we’ve embraced women’s strength, individuality, and elegance through thoughtfully designed apparel. Created by sisters Rosie and Ashi, GRACE+EMMA empowers women to express themselves authentically while feeling their best. We are size inclusive XS-3XL and open pack. \n\nOur name reflects our mission: grace in how we move through life and Emma, the vibrant, modern woman embodying confidence and compassion. Our collections blend timeless style with contemporary trends, offering versatile pieces for every moment—from coffee dates to classrooms, community events to cocktail hours.\n\nWe’re more than a clothing brand—we’re a community. Every stitch celebrates the diverse lives of the women who wear our designs. With soft textures, flattering fits, and bright, joyful colors, GRACE+EMMA inspires and uplifts. Whether stepping into a new chapter, chasing dreams, or savoring little moments, we’re here to be part of your journey.\n\nAt GRACE+EMMA, we believe in leading with grace, creating community, and embracing originality. Together, let’s celebrate the strength, beauty, and joy of women everywhere.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.466Z",
    importedBy: "entity-db-cli",
  },
};
